module.exports = __webpack_public_path__ + "img/gzh.6cc37d36.jpg";